import { OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';
import { BsAppLaunchFormService } from '../services/bs-app-launch-form.service';
import { BasespaceFormControl } from './bs-app-launch-form-control';

export abstract class BsAppLaunchFormControlBaseComponent<T extends BasespaceFormControl<any>> implements OnDestroy {
  abstract formControl: T;
  
  protected subs = new SubSink();

  constructor(protected bsAppLaunchFormService: BsAppLaunchFormService) {}

  onFocus(): void {
    this.formControl.trackValueForFormUpdates();
  }

  checkAndFireFormUpdate(): void {
    if (this.formControl.shouldTriggerFormUpdates()) {
      this.bsAppLaunchFormService.formUpdateTrigger$.next({ controlId: this.formControl.id });
    }
  }

  toggle(): void {
    if (this.formControl['togglers']) {
      this.formControl['togglers'].forEach((toggler: any) => {
        const selectValue = Array.isArray(this.formControl.value) 
          ? this.formControl.value 
          : [this.formControl.value];
        this.bsAppLaunchFormService.toggle(toggler.toggleOnValue, toggler.toggleFields, selectValue);
      });
    }
  }

  destroy(): void {
    this.formControl.destroy();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}

